import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../../services/auth.service';
import { AuthScreen } from '../../components/auth/AuthScreen';

export function OAuthCallbackView() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const handleCallback = () => {
            const token = searchParams.get('token');
            const userParam = searchParams.get('user');

            if (!token || !userParam) {
                setError('Authentication failed. Missing token or user data.');
                setTimeout(() => navigate('/login'), 3000);
                return;
            }

            try {
                const user = JSON.parse(userParam);

                // Store the token and user data
                authService.setToken(token);
                authService.setUser(user);

                // Use window.location to force a full page reload
                // This ensures AuthContext re-initializes with the new token
                window.location.href = '/';
            } catch (err) {
                setError('Authentication failed. Invalid user data.');
                setTimeout(() => navigate('/login'), 3000);
            }
        };

        handleCallback();
    }, [searchParams, navigate]);

    if (error) {
        return <AuthScreen error label="Sign-in failed" detail={`${error} Redirecting to login…`} />;
    }

    return <AuthScreen label="Signing you in" />;
}
